export default __webpack_public_path__ + "assets/94aa531e-7746-4df0-bb6e-349891f2eda5.woff2";